import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./theme.css";
import "./admin/admin.css";
import InquiryPage from "./pages/InquiryPage.js";
import PrivacyPage from "./pages/PrivacyPage.js";
import { AuthProvider } from "./admin/auth/AuthContext.js";
import AdminLayout from "./admin/AdminLayout.js";
import InboxPage from "./admin/pages/InboxPage.js";
import LeadDetailPage from "./admin/pages/LeadDetailPage.js";
import BrochuresPage from "./admin/pages/BrochuresPage.js";
import EmailTemplatesPage from "./admin/pages/EmailTemplatesPage.js";
import BatchesPage from "./admin/pages/BatchesPage.js";
import BatchDetailPage from "./admin/pages/BatchDetailPage.js";
import BatchReportPage from "./admin/pages/BatchReportPage.js";
import StudentDetailPage from "./admin/pages/StudentDetailPage.js";
import QuizManagerPage from "./admin/pages/QuizManagerPage.js";
import { StudentAuthProvider } from "./portal/auth/StudentAuthContext.js";
import StudentLayout from "./portal/StudentLayout.js";
import DashboardPage from "./portal/pages/DashboardPage.js";
import QuizzesPage from "./portal/pages/QuizzesPage.js";
import QuizRunnerPage from "./portal/pages/QuizRunnerPage.js";
import HomeworkPage from "./portal/pages/HomeworkPage.js";
import WelcomePage from "./portal/pages/WelcomePage.js";

const router = createBrowserRouter([
  { path: "/", element: <InquiryPage /> },
  { path: "/privacy", element: <PrivacyPage /> },
  {
    path: "/admin",
    element: (
      <AuthProvider>
        <AdminLayout />
      </AuthProvider>
    ),
    children: [
      { index: true, element: <InboxPage /> },
      { path: "inquiries/:id", element: <LeadDetailPage /> },
      { path: "batches", element: <BatchesPage /> },
      { path: "batches/:id", element: <BatchDetailPage /> },
      { path: "batches/:id/report", element: <BatchReportPage /> },
      { path: "students/:id", element: <StudentDetailPage /> },
      { path: "quizzes", element: <QuizManagerPage /> },
      { path: "brochures", element: <BrochuresPage /> },
      { path: "emails", element: <EmailTemplatesPage /> },
    ],
  },
  {
    path: "/portal",
    element: (
      <StudentAuthProvider>
        <StudentLayout />
      </StudentAuthProvider>
    ),
    children: [
      { index: true, element: <DashboardPage /> },
      { path: "quizzes", element: <QuizzesPage /> },
      { path: "quiz/:quizId", element: <QuizRunnerPage /> },
      { path: "quiz/:quizId/result/:windowDate", element: <QuizRunnerPage /> },
      { path: "homework", element: <HomeworkPage /> },
      { path: "welcome", element: <WelcomePage /> },
    ],
  },
]);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
